import React, { useState } from "react";
import Button, { AnswerButton } from "../button";
//import RoundManager from "../round-manager";
import useInterval from "../../hooks/useInterval";

import Modal from "../modal";
import CharacterPicker from "../character-picker";
import LoadingIndicator from "../LoadingIndicator";
import JoinGameErrorModal from "../modal/joinErrorModal";

export default function UI() {
  return (
    <JoinGameErrorModal
      hideClose={true}
      errorMsg={""}
      joinGame={() => null}
      createGame={() => null}
    />
  );
  // return <LoadingIndicator></LoadingIndicator>;
}
